// src/components/common/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ 
  isInitializing, 
  isLoadingInstitution, 
  selectedInstitution, 
  currentUser, 
  currentUserRoleInSelectedInstitution,
  children // Add children prop
}) => {
  // Show loading state
  if (isInitializing || isLoadingInstitution) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-slate-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-cyan-600 mx-auto mb-4"></div>
          <p className="text-slate-600 text-lg">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to home if no institution selected
  if (!selectedInstitution) {
    return <Navigate to="/" replace />;
  }

  // Redirect to login if not authenticated
  if (!currentUser || !currentUserRoleInSelectedInstitution) {
    return <Navigate to="/login" replace />;
  }

  // User is authenticated, render the children
  return children; // Change this from <Outlet /> to children
};

export default ProtectedRoute;